import React from 'react'
import { Link } from 'react-router-dom'
import { Price } from 'lib/shared/components'
import { Spinner } from 'lib/ui/components'
import { DEFAULT_CURRENCY_CODE } from 'lib/core/resources/constants'
import { OrderInfo } from '../../../Styled'
import { Order, useOrderDetail } from 'hooks/customerOrderDetails'

interface Prop {
  order: Order
}

interface StatusMap {
  [key: string]: string
}

const statusMap: StatusMap = {
  review_kount: 'Under Review',
  processing: 'Processing',
  fraud: 'Suspected Fraud',
  pending_payment: 'Pending Payment',
  payment_review: 'Payment Review',
  pending: 'Pending',
  holded: 'On Hold',
  complete: 'Complete',
  closed: 'Closed',
  canceled: 'Canceled'
}

export const Item = ({ order }: Prop) => {
  const { loadingOrderDetail, shippingName } = useOrderDetail(order.id)
  return (
    <OrderInfo key={order.id}>
      {loadingOrderDetail ? (
        <Spinner />
      ) : (
        <>
          <div>
            <p>Order #</p>
            <Link
              to={{
                pathname: '/customer/account/orders',
                state: { orderId: order.id }
              }}
              className='color-alpha'
            >
              <span>{order.increment_id}</span>
            </Link>
          </div>
          <div>
            <p>Ship to</p>
            <p className='notTooDark'><span>{shippingName}</span></p>
          </div>
          <div>
            <p>Total</p>
            <p className='notTooDark'>
              <Price
                value={order.grand_total}
                currency={DEFAULT_CURRENCY_CODE}
              />
            </p>
          </div>
          <div>
            <p className='notTooDark'>{statusMap[order.status ? order.status : 'processing']}</p>
          </div>
        </>
      )}
    </OrderInfo>
  )
}
